import $ from 'jQuery';

const $window = $(window);
const $titleGuard = $('.title__hp_guard');
const $title = $('.title__main');

const animationDuration = 750;

window.addEventListener('load', () => {
    if ($titleGuard.length === 1 && $title.length === 1) {
        scaleDownTitle().then(() =>
            $title.stop().animate(
                {
                    opacity: 1,
                },
                animationDuration
            )
        );
        $window.on('resize', () => {
            $title.css('font-size', '');
            scaleDownTitle();
        });
    }
});

function scaleDownTitle() {
    return new Promise(function (resolve) {
        if ($title.outerHeight() <= $titleGuard.outerHeight()) {
            resolve('done');
        } else {
            let fontSize = parseInt($title.css('font-size'));
            fontSize -= 5;
            $title.css('font-size', fontSize + 'px');
            resolve(scaleDownTitle());
        }
    });
}
